import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"
import type { DocumentStatus } from "../../domain/entities/document"

const STATUS_CLASS: Record<DocumentStatus, string> = {
  uploaded: "bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200",
  processing: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-200",
  extracting_metadata:
    "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-200",
  completed: "bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-200",
  failed: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200",
}

const STATUS_LABEL: Record<DocumentStatus, string> = {
  uploaded: "Uploaded",
  processing: "Processing",
  extracting_metadata: "Extracting metadata",
  completed: "Completed",
  failed: "Failed",
}

const SPINNING_STATUSES: DocumentStatus[] = ["processing", "extracting_metadata"]

export const StatusBadge = ({ status }: { status: DocumentStatus }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
      STATUS_CLASS[status],
    )}
  >
    {SPINNING_STATUSES.includes(status) && (
      <Loader2 className="size-3 animate-spin" />
    )}
    {STATUS_LABEL[status]}
  </span>
)
